import { render, staticRenderFns } from "./ReportLayoutModerno.vue?vue&type=template&id=0f6429fc&scoped=true"
import script from "./ReportLayoutModerno.vue?vue&type=script&lang=js"
export * from "./ReportLayoutModerno.vue?vue&type=script&lang=js"
import style0 from "./ReportLayoutModerno.vue?vue&type=style&index=0&id=0f6429fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6429fc",
  null
  
)

export default component.exports